import angular from 'angular';
import uiRouter from 'angular-ui-router';
import itemTemplatesComponent from './item-templates.component';
import dataTable from 'angular-material-data-table';

let itemTemplatesModule = angular.module('itemTemplates', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('itemTemplates', {
        url: '/itemTemplates',
        component: 'itemTemplates',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('itemTemplates', itemTemplatesComponent)
.name;

export default itemTemplatesModule;
